/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  ErrorResponseOfPtw100BadRequestException,
  GetSuggestedTrackItMeasurementParameterFiltersRequestDto,
  GetSuggestedTrackItMeasurementPropertyFiltersRequestDto,
  GetTrackItMeasurementsDto,
  ImportTrackItMeasurementForTaskAreaDto,
  ImportTrackItMeasurementForWorkStepDto,
  ImportTrackItMeasurementsForWorkItemDto,
  NumericTrackItDataTypeFilterDto,
  ODataPostProcessedResultsOfTrackItMeasurementInfoDto,
  PreviewImportTrackItMeasurementsForWorkItemDto,
  PtwImportDto,
  TrackItDataSequenceInfoDto,
  TrackItDataSequenceValuesDto,
  TrackItImportInfoDto,
  TrackItMeasurementFilterForCombinationDto,
  TrackItMeasurementInfoDto,
  TrackItMeasurementParameterFilterDto,
  TrackItMeasurementPropertyFilterDto,
  TrackItTaskWorkItemDto,
  TrackItTaskWorkResultDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    GetSuggestedTrackItMeasurementParameterFiltersRequestDtoFromJSON,
    GetSuggestedTrackItMeasurementParameterFiltersRequestDtoToJSON,
    GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoFromJSON,
    GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoToJSON,
    GetTrackItMeasurementsDtoFromJSON,
    GetTrackItMeasurementsDtoToJSON,
    ImportTrackItMeasurementForTaskAreaDtoFromJSON,
    ImportTrackItMeasurementForTaskAreaDtoToJSON,
    ImportTrackItMeasurementForWorkStepDtoFromJSON,
    ImportTrackItMeasurementForWorkStepDtoToJSON,
    ImportTrackItMeasurementsForWorkItemDtoFromJSON,
    ImportTrackItMeasurementsForWorkItemDtoToJSON,
    NumericTrackItDataTypeFilterDtoFromJSON,
    NumericTrackItDataTypeFilterDtoToJSON,
    ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON,
    ODataPostProcessedResultsOfTrackItMeasurementInfoDtoToJSON,
    PreviewImportTrackItMeasurementsForWorkItemDtoFromJSON,
    PreviewImportTrackItMeasurementsForWorkItemDtoToJSON,
    PtwImportDtoFromJSON,
    PtwImportDtoToJSON,
    TrackItDataSequenceInfoDtoFromJSON,
    TrackItDataSequenceInfoDtoToJSON,
    TrackItDataSequenceValuesDtoFromJSON,
    TrackItDataSequenceValuesDtoToJSON,
    TrackItImportInfoDtoFromJSON,
    TrackItImportInfoDtoToJSON,
    TrackItMeasurementFilterForCombinationDtoFromJSON,
    TrackItMeasurementFilterForCombinationDtoToJSON,
    TrackItMeasurementInfoDtoFromJSON,
    TrackItMeasurementInfoDtoToJSON,
    TrackItMeasurementParameterFilterDtoFromJSON,
    TrackItMeasurementParameterFilterDtoToJSON,
    TrackItMeasurementPropertyFilterDtoFromJSON,
    TrackItMeasurementPropertyFilterDtoToJSON,
    TrackItTaskWorkItemDtoFromJSON,
    TrackItTaskWorkItemDtoToJSON,
    TrackItTaskWorkResultDtoFromJSON,
    TrackItTaskWorkResultDtoToJSON,
} from '../models/index';

export interface ImportRequest {
    body?: string;
}

export interface GetDataSequenceFileRequest {
    dataSequenceId: number;
}

export interface GetDataSequenceValuesRequest {
    dataSequenceId: number;
}

export interface GetDataSequencesForMeasurementRequest {
    measurementId: number;
}

export interface GetFilteredTrackItMeasurementsRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
    getTrackItMeasurementsDto?: GetTrackItMeasurementsDto;
}

export interface GetSuggestedTrackItMeasurementParameterFiltersRequest {
    getSuggestedTrackItMeasurementParameterFiltersRequestDto?: GetSuggestedTrackItMeasurementParameterFiltersRequestDto;
}

export interface GetSuggestedTrackItMeasurementPropertyFiltersRequest {
    getSuggestedTrackItMeasurementPropertyFiltersRequestDto?: GetSuggestedTrackItMeasurementPropertyFiltersRequestDto;
}

export interface GetTrackItExecutionPreviewForTaskAreaRequest {
    importTrackItMeasurementForTaskAreaDto?: ImportTrackItMeasurementForTaskAreaDto;
}

export interface GetTrackItExecutionPreviewForWorkStepRequest {
    importTrackItMeasurementForWorkStepDto?: ImportTrackItMeasurementForWorkStepDto;
}

export interface GetTrackItMeasurementForDetailViewRequest {
    id: number;
}

export interface GetTrackItMeasurementsForOverviewRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetTrackItTaskExecutionPreviewForWorkItemRequest {
    previewImportTrackItMeasurementsForWorkItemDto?: PreviewImportTrackItMeasurementsForWorkItemDto;
}

export interface ImportFromFileRequest {
    filePath: string;
}

export interface ImportTrackItMeasurementForWorkStepRequest {
    importTrackItMeasurementForWorkStepDto?: ImportTrackItMeasurementForWorkStepDto;
}

export interface ImportTrackItMeasurementsForWorkItemRequest {
    importTrackItMeasurementsForWorkItemDto?: ImportTrackItMeasurementsForWorkItemDto;
}

export interface ValidateTrackItMeasurementParameterFiltersRequest {
    trackItMeasurementFilterForCombinationDto?: Array<TrackItMeasurementFilterForCombinationDto>;
}

/**
 * 
 */
export class TrackItImportApi extends runtime.BaseAPI {

    /**
     */
    async _importRaw(requestParameters: ImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => PtwImportDtoFromJSON(jsonValue), "PtwImportDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => PtwImportDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async _import(requestParameters: ImportRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['_importRaw']>>, PtwImportDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = PtwImportDto;

         const response = this._importRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getDataSequenceFileRaw(requestParameters: GetDataSequenceFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['dataSequenceId'] == null) {
            throw new runtime.RequiredError(
                'dataSequenceId',
                'Required parameter "dataSequenceId" was null or undefined when calling getDataSequenceFile().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/data-sequences/{dataSequenceId}/file`.replace(`{${"dataSequenceId"}}`, encodeURIComponent(String(requestParameters['dataSequenceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.BlobApiResponse(response);
					}
          case 404: { 
						return new runtime.BlobApiResponse(response);
					}
					default: {
						return new runtime.BlobApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async getDataSequenceFile(requestParameters: GetDataSequenceFileRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getDataSequenceFileRaw']>>, Blob>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Blob;

         const response = this.getDataSequenceFileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getDataSequenceValuesRaw(requestParameters: GetDataSequenceValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['dataSequenceId'] == null) {
            throw new runtime.RequiredError(
                'dataSequenceId',
                'Required parameter "dataSequenceId" was null or undefined when calling getDataSequenceValues().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/data-sequences/{dataSequenceId}/values`.replace(`{${"dataSequenceId"}}`, encodeURIComponent(String(requestParameters['dataSequenceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItDataSequenceValuesDtoFromJSON(jsonValue), "TrackItDataSequenceValuesDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItDataSequenceValuesDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getDataSequenceValues(requestParameters: GetDataSequenceValuesRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getDataSequenceValuesRaw']>>, TrackItDataSequenceValuesDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItDataSequenceValuesDto;

         const response = this.getDataSequenceValuesRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getDataSequencesForMeasurementRaw(requestParameters: GetDataSequencesForMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['measurementId'] == null) {
            throw new runtime.RequiredError(
                'measurementId',
                'Required parameter "measurementId" was null or undefined when calling getDataSequencesForMeasurement().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurement-data-sequences/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters['measurementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItDataSequenceInfoDtoFromJSON), "TrackItDataSequenceInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItDataSequenceInfoDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getDataSequencesForMeasurement(requestParameters: GetDataSequencesForMeasurementRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getDataSequencesForMeasurementRaw']>>, Array<TrackItDataSequenceInfoDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TrackItDataSequenceInfoDto>;

         const response = this.getDataSequencesForMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getFilteredTrackItMeasurementsRaw(requestParameters: GetFilteredTrackItMeasurementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/get-filtered-measurements`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTrackItMeasurementsDtoToJSON(requestParameters['getTrackItMeasurementsDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfTrackItMeasurementInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getFilteredTrackItMeasurements(requestParameters: GetFilteredTrackItMeasurementsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getFilteredTrackItMeasurementsRaw']>>, ODataPostProcessedResultsOfTrackItMeasurementInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfTrackItMeasurementInfoDto;

         const response = this.getFilteredTrackItMeasurementsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSuggestedTrackItDataTypeFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/suggested-datatype-filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumericTrackItDataTypeFilterDtoFromJSON), "NumericTrackItDataTypeFilterDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumericTrackItDataTypeFilterDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getSuggestedTrackItDataTypeFilters(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getSuggestedTrackItDataTypeFiltersRaw']>>, Array<NumericTrackItDataTypeFilterDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<NumericTrackItDataTypeFilterDto>;

         const response = this.getSuggestedTrackItDataTypeFiltersRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSuggestedTrackItMeasurementParameterFiltersRaw(requestParameters: GetSuggestedTrackItMeasurementParameterFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/suggested-measurement-parameters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSuggestedTrackItMeasurementParameterFiltersRequestDtoToJSON(requestParameters['getSuggestedTrackItMeasurementParameterFiltersRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItMeasurementParameterFilterDtoFromJSON), "TrackItMeasurementParameterFilterDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItMeasurementParameterFilterDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getSuggestedTrackItMeasurementParameterFilters(requestParameters: GetSuggestedTrackItMeasurementParameterFiltersRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getSuggestedTrackItMeasurementParameterFiltersRaw']>>, Array<TrackItMeasurementParameterFilterDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TrackItMeasurementParameterFilterDto>;

         const response = this.getSuggestedTrackItMeasurementParameterFiltersRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSuggestedTrackItMeasurementPropertyFiltersRaw(requestParameters: GetSuggestedTrackItMeasurementPropertyFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/suggested-measurement-properties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoToJSON(requestParameters['getSuggestedTrackItMeasurementPropertyFiltersRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItMeasurementPropertyFilterDtoFromJSON), "TrackItMeasurementPropertyFilterDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItMeasurementPropertyFilterDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getSuggestedTrackItMeasurementPropertyFilters(requestParameters: GetSuggestedTrackItMeasurementPropertyFiltersRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getSuggestedTrackItMeasurementPropertyFiltersRaw']>>, Array<TrackItMeasurementPropertyFilterDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TrackItMeasurementPropertyFilterDto>;

         const response = this.getSuggestedTrackItMeasurementPropertyFiltersRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSuggestedUnitsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/suggested-units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.JSONApiResponse<any>(response);
					}
					default: {
						return new runtime.JSONApiResponse<any>(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async getSuggestedUnits(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getSuggestedUnitsRaw']>>, Array<string>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<string>;

         const response = this.getSuggestedUnitsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItExecutionPreviewForTaskAreaRaw(requestParameters: GetTrackItExecutionPreviewForTaskAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurement-for-task-area`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportTrackItMeasurementForTaskAreaDtoToJSON(requestParameters['importTrackItMeasurementForTaskAreaDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue), "TrackItTaskWorkResultDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItExecutionPreviewForTaskArea(requestParameters: GetTrackItExecutionPreviewForTaskAreaRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItExecutionPreviewForTaskAreaRaw']>>, TrackItTaskWorkResultDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItTaskWorkResultDto;

         const response = this.getTrackItExecutionPreviewForTaskAreaRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItExecutionPreviewForWorkStepRaw(requestParameters: GetTrackItExecutionPreviewForWorkStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurement-for-workstep-preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportTrackItMeasurementForWorkStepDtoToJSON(requestParameters['importTrackItMeasurementForWorkStepDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue), "TrackItTaskWorkResultDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItExecutionPreviewForWorkStep(requestParameters: GetTrackItExecutionPreviewForWorkStepRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItExecutionPreviewForWorkStepRaw']>>, TrackItTaskWorkResultDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItTaskWorkResultDto;

         const response = this.getTrackItExecutionPreviewForWorkStepRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItImportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/imports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItImportInfoDtoFromJSON), "TrackItImportInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItImportInfoDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItImports(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItImportsRaw']>>, Array<TrackItImportInfoDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TrackItImportInfoDto>;

         const response = this.getTrackItImportsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItMeasurementForDetailViewRaw(requestParameters: GetTrackItMeasurementForDetailViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTrackItMeasurementForDetailView().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurement/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItMeasurementInfoDtoFromJSON(jsonValue), "TrackItMeasurementInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItMeasurementInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItMeasurementForDetailView(requestParameters: GetTrackItMeasurementForDetailViewRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItMeasurementForDetailViewRaw']>>, TrackItMeasurementInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItMeasurementInfoDto;

         const response = this.getTrackItMeasurementForDetailViewRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItMeasurementsForOverviewRaw(requestParameters: GetTrackItMeasurementsForOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfTrackItMeasurementInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItMeasurementsForOverview(requestParameters: GetTrackItMeasurementsForOverviewRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItMeasurementsForOverviewRaw']>>, ODataPostProcessedResultsOfTrackItMeasurementInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfTrackItMeasurementInfoDto;

         const response = this.getTrackItMeasurementsForOverviewRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTrackItTaskExecutionPreviewForWorkItemRaw(requestParameters: GetTrackItTaskExecutionPreviewForWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/measurement-for-workitem-preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreviewImportTrackItMeasurementsForWorkItemDtoToJSON(requestParameters['previewImportTrackItMeasurementsForWorkItemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItTaskWorkResultDtoFromJSON), "TrackItTaskWorkResultDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackItTaskWorkResultDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTrackItTaskExecutionPreviewForWorkItem(requestParameters: GetTrackItTaskExecutionPreviewForWorkItemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['getTrackItTaskExecutionPreviewForWorkItemRaw']>>, Array<TrackItTaskWorkResultDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TrackItTaskWorkResultDto>;

         const response = this.getTrackItTaskExecutionPreviewForWorkItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * This route is only used for testing and shall be removed for the final product.
     */
    async importFromFileRaw(requestParameters: ImportFromFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['filePath'] == null) {
            throw new runtime.RequiredError(
                'filePath',
                'Required parameter "filePath" was null or undefined when calling importFromFile().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/import-from-file/{filePath}`.replace(`{${"filePath"}}`, encodeURIComponent(String(requestParameters['filePath']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => PtwImportDtoFromJSON(jsonValue), "PtwImportDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => PtwImportDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * This route is only used for testing and shall be removed for the final product.
     */
     async importFromFile(requestParameters: ImportFromFileRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['importFromFileRaw']>>, PtwImportDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = PtwImportDto;

         const response = this.importFromFileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async importTrackItMeasurementForWorkStepRaw(requestParameters: ImportTrackItMeasurementForWorkStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/import-measurement-for-workstep`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportTrackItMeasurementForWorkStepDtoToJSON(requestParameters['importTrackItMeasurementForWorkStepDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue), "TrackItTaskWorkResultDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkResultDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async importTrackItMeasurementForWorkStep(requestParameters: ImportTrackItMeasurementForWorkStepRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['importTrackItMeasurementForWorkStepRaw']>>, TrackItTaskWorkResultDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItTaskWorkResultDto;

         const response = this.importTrackItMeasurementForWorkStepRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async importTrackItMeasurementsForWorkItemRaw(requestParameters: ImportTrackItMeasurementsForWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/import-measurement-for-workitem`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportTrackItMeasurementsForWorkItemDtoToJSON(requestParameters['importTrackItMeasurementsForWorkItemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkItemDtoFromJSON(jsonValue), "TrackItTaskWorkItemDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TrackItTaskWorkItemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async importTrackItMeasurementsForWorkItem(requestParameters: ImportTrackItMeasurementsForWorkItemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['importTrackItMeasurementsForWorkItemRaw']>>, TrackItTaskWorkItemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TrackItTaskWorkItemDto;

         const response = this.importTrackItMeasurementsForWorkItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async validateTrackItMeasurementParameterFiltersRaw(requestParameters: ValidateTrackItMeasurementParameterFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/trackit-import/validate-measurement-parameter-filters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['trackItMeasurementFilterForCombinationDto']!.map(TrackItMeasurementFilterForCombinationDtoToJSON),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async validateTrackItMeasurementParameterFilters(requestParameters: ValidateTrackItMeasurementParameterFiltersRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TrackItImportApi['validateTrackItMeasurementParameterFiltersRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateTrackItMeasurementParameterFiltersRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
